import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Shigar Inc</h3>
            <p>Growing IT consulting firm in the UK, working with top executives to achieve sustainable success and produce realistic, enduring, and measurable results.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/home/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Consulting</li>
              <li>Mobile Applications</li>
              <li>Telecom Solutions</li>
              <li>SAP & ERP</li>
              <li>Digital Marketing</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>United Kingdom</p>
            <p>IT Consulting Services</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Shigar Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
